import { render, staticRenderFns } from "./versionUpdate.vue?vue&type=template&id=d24d5b66&scoped=true"
import script from "./versionUpdate.vue?vue&type=script&lang=js"
export * from "./versionUpdate.vue?vue&type=script&lang=js"
import style0 from "./versionUpdate.vue?vue&type=style&index=0&id=d24d5b66&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d24d5b66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d24d5b66')) {
      api.createRecord('d24d5b66', component.options)
    } else {
      api.reload('d24d5b66', component.options)
    }
    module.hot.accept("./versionUpdate.vue?vue&type=template&id=d24d5b66&scoped=true", function () {
      api.rerender('d24d5b66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/appSet/versionUpdate.vue"
export default component.exports